export default "https://kr-a.kakaopagecdn.com/web/qa/5.5.0/static/auth/login-ico-sns-google-32-73f1df29a9046c3afbfdd98e49328ca3.svg";